import { extendTheme } from '@chakra-ui/react';

import components from './components';
import colors from './colors';
import fonts from './fonts';
import styles from './styles';
import textStyles from './textStyles';

import 'react-datepicker/dist/react-datepicker.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const theme = extendTheme({
  fonts,
  styles,
  colors,
  components,
  textStyles,
  sizes: {
    container: {
      xl: '1440px' // 1200px + 2 x 16px (container + paddings)
    }
  },
  breakpoints: {
    base: '0em', // 0px
    sm: '30em', // ~480px
    md: '48em', // ~768px
    lg: '62em', // ~992px
    xl: '80em', // ~1280px
    '2xl': '90em', // ~1440px
    '3xl': '100em' // ~1600px
  }
});

export default theme;
